import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setDesignHasStructureChangedReducer = (state: DesignState, action: PayloadAction<boolean>) => {
  state.hasStructureChanged = action.payload;
};

export default setDesignHasStructureChangedReducer;
